// extracted by mini-css-extract-plugin
export default {"container":"FrequencyList_container__DUWRz","items":"FrequencyList_items__jxAbM","item":"FrequencyList_item__-8of3"};